export default "__VITE_ASSET__BgsfHGLI__"